import React, { useEffect, useRef } from 'react';
import { MapContainer, TileLayer, Marker, Popup, Polyline, useMap } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import { useFormatMoneda, useWhatsAppNumero } from '../utils/moneda';
import { mensajeRecordatorio } from '../utils/whatsapp';
import { useLicencia } from '../context/LicenciaContext';

// Fix default marker icons in CRA
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});

function makeIcon(numero, visitado, vencido) {
  const color = visitado ? '#34d399' : vencido ? '#f87171' : '#38bdf8';
  const svg = `
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="40" viewBox="0 0 32 40">
      <path d="M16 0C7.2 0 0 7.2 0 16c0 12 16 24 16 24S32 28 32 16C32 7.2 24.8 0 16 0z"
        fill="${color}" stroke="#fff" stroke-width="2"/>
      <circle cx="16" cy="16" r="8" fill="white"/>
      <text x="16" y="20" text-anchor="middle" font-size="10" font-weight="bold" fill="${color}">${numero}</text>
    </svg>
  `;
  return L.divIcon({
    html: svg,
    iconSize: [32, 40],
    iconAnchor: [16, 40],
    popupAnchor: [0, -40],
    className: '',
  });
}

function FitBounds({ positions }) {
  const map = useMap();
  useEffect(() => {
    if (positions.length > 0) {
      const bounds = L.latLngBounds(positions);
      map.fitBounds(bounds, { padding: [40, 40] });
    }
  }, [positions, map]);
  return null;
}

export default function MapaRuta({ clientes, cobrosHoy = [] }) {
  const numeroWhatsApp = useWhatsAppNumero();
  const formatMoneda = useFormatMoneda();
  const { numeroEmpresa } = useLicencia();
  const conCoordenadas = clientes.filter(c => c.lat && c.lng);
  const positions = conCoordenadas.map(c => [c.lat, c.lng]);
  const defaultCenter = conCoordenadas.length > 0
    ? [conCoordenadas[0].lat, conCoordenadas[0].lng]
    : [4.711, -74.0721]; // Bogotá por defecto

  const cobradosIds = new Set(cobrosHoy.map(c => c.cliente_id));

  return (
    <MapContainer
      center={defaultCenter}
      zoom={13}
      style={{ height: '100%', width: '100%', borderRadius: '10px' }}
    >
      <TileLayer
        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
      />

      {conCoordenadas.length > 1 && (
        <Polyline
          positions={positions}
          pathOptions={{ color: '#38bdf8', weight: 3, opacity: 0.7, dashArray: '8 6' }}
        />
      )}

      {conCoordenadas.map((cliente, i) => {
        const visitado = cobradosIds.has(cliente.id);
        const vencido = (cliente.cuotas_vencidas || 0) > 0;
        return (
          <Marker
            key={cliente.id}
            position={[cliente.lat, cliente.lng]}
            icon={makeIcon(i + 1, visitado, vencido)}
          >
            <Popup>
              <div style={{ minWidth: '180px' }}>
                <strong style={{ fontSize: '14px' }}>#{i + 1} {cliente.nombre}</strong>
                <br />
                <span style={{ color: 'var(--text-3)', fontSize: '12px' }}>{cliente.documento}</span>
                {cliente.direccion && (
                  <><br /><span style={{ fontSize: '12px' }}>{cliente.direccion}</span></>
                )}
                {cliente.saldo_pendiente > 0 && (
                  <><br /><span style={{ color: '#38bdf8', fontWeight: 'bold', fontSize: '13px' }}>
                    Saldo: ${parseFloat(cliente.saldo_pendiente).toLocaleString()}
                  </span></>
                )}
                {vencido && (
                  <><br /><span style={{ color: '#f87171', fontSize: '12px' }}>
                    {cliente.cuotas_vencidas} cuota(s) vencida(s)
                  </span></>
                )}
                {visitado && (
                  <><br /><span style={{ color: '#34d399', fontWeight: 'bold', fontSize: '12px' }}>
                    Cobrado hoy
                  </span></>
                )}
                {cliente.telefono && (
                  <><br />
                  <a href={`https://wa.me/${numeroWhatsApp(cliente.telefono)}?text=${encodeURIComponent(mensajeRecordatorio(cliente, formatMoneda, numeroEmpresa))}`}
                    target="_blank" rel="noreferrer"
                    style={{ color: '#38bdf8', fontSize: '12px' }}>
                    WhatsApp: {cliente.telefono}
                  </a></>
                )}
              </div>
            </Popup>
          </Marker>
        );
      })}

      {conCoordenadas.length > 0 && <FitBounds positions={positions} />}
    </MapContainer>
  );
}
